export const DashboardMenu = [
    {
        name: 'Dashboard',
        url: '/dashboard',
        icon: '/icons/dashboard.svg',
        show: false,
        color: 'blue',
        sub: []

    },
    {
        name: 'Blogs',
        url: '/dashboard/Blog',
        icon: '/icons/blog.svg',
        show: true,
        color: '#CCD5AE',
        sub: [

            {
                name: 'Article List',
                url: '/dashboard/Blog/Articles',
                icon: '/icons/text.svg',
            },
            {
                name: 'Blog Group',
                url: '/dashboard/Blog/list',
                icon: '/icons/folder.svg',

            }
        ]

    },



    {
        name: 'Setting',
        url: '/dashboard/Setting',
        icon: '/icons/setting.svg',
        show: true,
        color: '#E0E5B6',
        sub: [
            {
                name: 'General',
                url: '/dashboard/Setting/general',
                icon: '/icons/folder.svg',


            },
            {
                name: 'Social Network',
                url: '/dashboard/Setting/socialnetwork',
                icon: '/icons/folder.svg',


            },
            {
                name: 'Contact',
                url: '/dashboard/Setting/contact',
                icon: '/icons/folder.svg',


            },
            {
                name: 'User',
                url: '/dashboard/User/list',
                icon: '/icons/folder.svg',


            },
            {
                name: 'Affiliate Settings',
                url: '/dashboard/Setting/affiliate',
                icon: '/icons/folder.svg',
            },
             {
                name: 'Languages Setting',
                url: '/dashboard/Setting/language',
                icon: '/icons/folder.svg',
            },
        ]

    },

    {
        name: 'Feature',
        url: '/dashboard/Feature',
        icon: '/icons/feture.svg',
        show: true,
        color: '#E8B86D',
        sub: [
            {
                name: 'Group List',
                url: '/dashboard/Testimonial/GroupList',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Menus',
                url: '/dashboard/Feature/Menus',
                icon: '/icons/folder.svg',
            },

            {
                name: 'Story',
                url: '/dashboard/Feature/Story',
                icon: '/icons/folder.svg',


            },
            {
                name: 'Testimonial',
                url: '/dashboard/Testimonial/GroupList',
                icon: '/icons/folder.svg',
            },
            {
                name: 'فرم های درخواست',
                url: '/dashboard/Feature/RequestForms',
                icon: '/icons/folder.svg',
            },
            {
                name: 'نقشه ایران',
                url: '/dashboard/Feature/IranMap',
                icon: '/icons/folder.svg',
            },
            {
                name: 'ریداریکت آدرس',
                url: '/dashboard/Feature/RedirectAddress',
                icon: '/icons/folder.svg',
            }

        ]

    },
    // {
    //     name: 'Products',
    //     url: '/dashboard/Products',
    //     icon: '/icons/box.svg',
    //     show: true,
    //     color: '#CCD5EE',
    //     sub: [

    //         {
    //             name: 'Products List',
    //             url: '/dashboard/Products/Products',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'Products Group',
    //             url: '/dashboard/Products/ProductsGroup',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'Brand',
    //             url: '/dashboard/Products/Brands',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'Gift Products',
    //             url: '/dashboard/Products/GiftProducts',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'Price Group',
    //             url: '/dashboard/PriceGroup',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'لیست فاکتورها',
    //             url: '/dashboard/User/invoices',
    //             icon: '/icons/folder.svg',


    //         },
    //         {
    //             name: 'Brand',
    //             url: '/dashboard/Products/Brands',
    //             icon: '/icons/folder.svg',


    //         },

    //     ]

    // },
    {
        name: 'Gallery',
        url: '/dashboard/Gallery',
        icon: '/icons/gallery.svg',
        show: true,
        color: '#FAEDCE',
        sub: [
            {
                name: 'Sliders',
                url: '/dashboard/Gallery/list',
                icon: '/icons/folder.svg',


            },
            {
                name: 'Gallery',
                url: '/dashboard/Gallery/gallery',
                icon: '/icons/folder.svg',


            }

        ]

    },
    {
        name: 'Comments',
        url: '/dashboard/Comments',
        icon: '/icons/folder.svg',
        show: true,
        color: '#E8B86D',
        sub: [
            {
                name: 'List Comments',
                url: '/dashboard/Comments',
                icon: '/icons/folder.svg',
            }
        ]
    },
    {
        name: 'Affiliate',
        url: '/dashboard/Affiliate',
        icon: '/icons/folder.svg',
        show: true,
        color: '#9B59B6',
        sub: [
            {
                name: 'Affiliate Requests',
                url: '/dashboard/Affiliate/Requests',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Affiliate Orders',
                url: '/dashboard/Affiliate/Orders',
                icon: '/icons/folder.svg',
            }
        ]
    },
    {
        name: 'Campaign',
        url: '/dashboard/Campaign',
        icon: '/icons/folder.svg',
        show: true,
        color: '#8E44AD',
        sub: [
            {
                name: 'Campaign Requests',
                url: '/dashboard/Campaign/Requests',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Time Slots',
                url: '/dashboard/Campaign/TimeSlots',
                icon: '/icons/folder.svg',
            }
        ]
    },
    // {
    //     name: 'Marketplace Management',
    //     url: '/dashboard/Marketplace',
    //     icon: '/icons/folder.svg',
    //     show: true,
    //     color: '#2E7D32',
    //     sub: [
    //         {
    //             name: 'List Marketplace',
    //             url: '/dashboard/Marketplace/list',
    //             icon: '/icons/folder.svg',
    //         },
    //         {
    //             name: 'Add Marketplace',
    //             url: '/dashboard/Marketplace/new',
    //             icon: '/icons/folder.svg',
    //         }
    //     ]
    // },
    {
        name: 'Real Estate System',
        url: '/dashboard/RealEstate',
        icon: '/icons/folder.svg',
        show: true,
        color: '#1565C0',
        sub: [
            {
                name: 'City Management',
                url: '/dashboard/RealEstate/cities',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Feature Management',
                url: '/dashboard/RealEstate/facilities',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Attribute Management',
                url: '/dashboard/RealEstate/attributes',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Property Management',
                url: '/dashboard/RealEstate/properties',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Meter sale requests',
                url: '/dashboard/RealEstate/meter-sales',
                icon: '/icons/folder.svg',
            },
            {
                name: 'Agent Management',
                url: '/dashboard/RealEstate/agents',
                icon: '/icons/folder.svg',
            }
        ]
    },


    // {
    //     name:'Menus',
    //     url:'/dashboard/Menus',
    //     icon:'/icons/menu.svg',
    //     show:true,
    //     color:'#FEFAE0',
    //     sub:[
    //         {
    //             name:'Menu List',
    //             url:'/dashboard/Menus/list',

    //         }

    //     ]

    // },
    // {
    //     name:'About',
    //     url:'/dashboard/about',
    //     icon:'/icons/about.svg',
    //     show:true,
    //     color:'#CEDF9F',
    //     sub:[ ]

    // },
]